// Smooth scroll jump links that properly reset focus for keyboard users
// https://css-tricks.com/smooth-scrolling-accessibility/

// Options
var targetOffsetTop = 30;
var duration = 13; // multiplied by Math.sqrt(scrollDistance)

// Check for the reduce motion media query
var motionQuery = matchMedia('(prefers-reduced-motion)');
var animateScroll = true;

function handleReduceMotionChanged() {
  if (motionQuery.matches) {
    animateScroll = false;
  } else {
    animateScroll = true;
  }
}

motionQuery.addListener(handleReduceMotionChanged);
handleReduceMotionChanged(); // trigger once on load

var focusTarget =  function($target) {
  $target.focus(); // Setting focus
  if ($target.is(":focus")){ // Checking if the target was focused
    return false;
  } else {
    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
    $target.focus(); // Setting focus
  };
}

var smoothScroll = function (element) {
  var $target = $(element.hash);

  if ($target.length) {
    event.preventDefault();

    var scrollDistance = $target.offset().top - targetOffsetTop;
    if (scrollDistance < 0) scrollDistance = 0;

    var windowHeight = $(window).height();
    var documentHeight = $(document).height();

    // Make sure we don't try to scroll farther than the bottom of the page
    if (scrollDistance + windowHeight > documentHeight) {
      var scrollDistance = documentHeight - windowHeight;
    }

    var scrollDuration = duration * Math.sqrt(scrollDistance);

    // If iOS reduce motion setting is false, animate scroll instead of jump
    if (animateScroll === false) {
      scrollDuration = 0;
    }

    $('html, body').animate({
      scrollTop: scrollDistance,
    }, scrollDuration).promise().then(function () {
      // After animation is complete, focus on the element
      focusTarget($target);
    });
    return false;
  } else {
    // console.log('no target')
    return true;
  }
};

export { smoothScroll };
